<div class="breadcrumb-container">
	<div class="container-fluid">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<a [routerLink]="['/dashboard/welcome']">{{ 'breadcrumb.label.myConnectCaseCenter' | translate }}</a>
			</li>
			<li *ngFor="let breadcrumb of breadcrumbsData" class="breadcrumb-item">
				<ng-container *ngIf="breadcrumb.noLink">
					<a [routerLink]="[breadcrumb.url]">{{ translateMenu(breadcrumb.label) }}</a>
				</ng-container>
				<ng-container *ngIf="!breadcrumb.noLink">
					<span class="text-white">{{ translateMenu(breadcrumb.label) }}</span>
				</ng-container>
			</li>
		</ol>
	</div>
</div>
